export default {
  title: 'Personlige oplysninger',
  buttons: {
    save: 'Gem',
  },
  toasts: {
    personal_info_updated_successfully: 'Dine oplysninger er gemt',
  },
};
